module.exports = __webpack_public_path__ + "img/MB_lobby.59eb103a.jpg";